import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qtg8rU2C9UAtzRSdRA16ji/copper-stone-logo-transparent.png';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#'
  }, {
    name: 'Buyers',
    href: '#'
  }, {
    name: 'Sellers',
    href: '#'
  }, {
    name: 'Communities',
    href: '#communities'
  }, {
    name: 'Meet the Team',
    href: '#team'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const handleCtaClick = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
    setMobileMenuOpen(false);
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-stone-900 border-b border-brand-copper/30 py-2' : 'bg-gradient-to-b from-brand-stone-900/90 to-transparent py-3'}`} data-id="element-105">
        <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-106">
          {/* Logo */}
          <a href="#" className="flex items-center z-50 shrink-0" data-id="element-107">
            <img src={LOGO_URL} alt="Copper & Stone Realty" className="h-10 md:h-12 w-auto object-contain" data-id="element-108" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-8" data-id="element-109">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/90 hover:text-white text-sm font-medium transition-colors relative group" data-id="element-110">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-brand-copper transition-all duration-300 group-hover:w-full" data-id="element-111"></span>
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden lg:flex items-center gap-6" data-id="element-112">
            <a href="tel:3035475468" className="text-white/90 hover:text-brand-copper transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-113">
              <Phone size={16} data-id="element-114" />
              (303) 547-5468
            </a>
            <button onClick={handleCtaClick} className="bg-brand-copper hover:bg-brand-copper/90 text-white px-6 py-2.5 rounded-md text-sm font-medium transition-colors" data-id="element-115">
              Get Started
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="lg:hidden text-white z-50 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-116">
            {mobileMenuOpen ? <X size={28} data-id="element-117" /> : <Menu size={28} data-id="element-118" />}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 bg-brand-stone-900 z-40 transition-transform duration-500 ease-in-out flex flex-col justify-center items-center ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-119">
        <nav className="flex flex-col items-center gap-8 w-full px-6" data-id="element-120">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white text-2xl font-serif hover:text-brand-copper transition-colors" onClick={() => setMobileMenuOpen(false)} data-id="element-121">
              {link.name}
            </a>)}
          <div className="w-16 h-px bg-brand-copper/30 my-4" data-id="element-122"></div>
          <a href="tel:3035475468" className="text-white flex items-center gap-3 text-xl" data-id="element-123">
            <Phone size={20} className="text-brand-copper" data-id="element-124" />
            (303) 547-5468
          </a>
          <button onClick={handleCtaClick} className="w-full max-w-xs bg-brand-copper text-white py-4 rounded-md text-lg font-medium mt-4" data-id="element-125">
            Get Started
          </button>
        </nav>
      </div>
    </>;
}